import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { TopSlider } from '../Common/TopSlider';
import { RecommandedSeller } from '../HomePage/RecommandedSeller';
import { PaymentMethod } from '../HomePage/PaymentMethod';
import { FeedBack } from '../HomePage/Feedback';
import { CategoryList } from '../HomePage/CategoryList';
import { Header } from '../Common/Header';
import { Footer } from '../Common/Footer';
import ProductsUpload from '../../Models/ProductsUpload';
import Affiliator from '../../Models/Affiliator';
import { Spinner } from 'reactstrap';
class HomePageAffiliator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categories: [],
            id: '',
            status: '',
        }
        var link = window.location.pathname;
        // window.localStorage.setItem('link', link)
        let url = window.location.pathname.split('/');
        let id = url[url.length - 1];
        console.log(id)
        let data = {
            code: id,
        }
        Affiliator.sendAffiliatorHomeLink(data).then(res => {
            console.log(res.data.status)
            if (res.data.status === 200) {
                window.localStorage.setItem('aff-id', res.data.id)
                this.props.history.push({
                    pathname: '/',
                    id: res.data.id
                })
                this.setState({ id: res.data.id })
            } else {
                this.setState({ status: res.data.status })
            }
        })
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        // console.log(this.state.cookiesAll)
        if (this.state.id) {
            return (
                <div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="" style={{ height: '300px' }}></div>
                            <div className="text-center mt-5">
                                <Spinner color="primary" size="150" />
                            </div>
                        </div>
                    </div>
                </div >
            )
        } else if (this.state.status) {
            return (
                <div>
                    <h1>Page not found</h1>
                    <p>We're sorry, we couldn't find the page you requested.</p>
                </div>
            )
        } else {
            return (
                <div className="container-fluid">
                    <div className="container">
                        <div className="" style={{ height: '300px' }}></div>
                        <div className="text-center mt-5">
                            <Spinner color="primary" size="150" />
                        </div>
                    </div>
                </div>
            )
        }
    }
}

export { HomePageAffiliator };